module.exports = __webpack_public_path__ + "img/15.72bde99c.jpg";